<template>
  <template v-if="hasOptions(filters.category)">

    <div class="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
      <template v-for="subcategory, i in filters.category.options" :key="i"> 
        <a :href="subcategory.link" :title="subcategory.title">
            <div class="flex aspect-[2.51] gap-4 rounded-[8px] overflow-hidden shadow-base-narrow border border-charcoal/[7%] hover:border-lime-green-hover">
              <!-- First column: Image -->
              <div class="aspect-square flex items-center justify-center relative basis-[calc(100%/2.51)]">
                <picture class="absolute inset-0">
                  <source :srcset="subcategory.image.webp" media="(max-width: 767px)" type="image/webp">
                  <img
                      width="100"
                      height="100"
                      :alt="subcategory.title"
                      :data-src="subcategory.image.source"
                      class="category-image lazyload"
                  >
                </picture>
              </div>
              <!-- Second column: Title and Product count -->
              <div class="flex flex-col justify-center flex-1 pr-2">
                <span class="block text-[16px] font-medium whitespace-pre-wrap ">{{ subcategory.title }}</span>
                <p class="text-[14px]">{{ subcategory.count }} {{ in18['page_products'] }}</p>
              </div>
            </div>
          </a>
      </template>
    </div>
    <hr>
  </template>
  <div v-if="isLoading" class="loader"></div>
</template>

<script>
export default {
  name:    "catalogSubcategories",
  props:   {
    filters:   Object,
    in18:      Object,
    isLoading: Boolean,
  },
  methods: {
    /**
     * Check if a filter has options.
     * @param {Object} filter - The filter to check.
     * @returns {boolean} - True if the filter has options, otherwise false.
     */
    hasOptions(filter) {
      return filter && filter.options && filter.options.length > 0;
    },
  }
};
</script>

<style scoped>
/* Add CSS styling for your subcategory cards */
.subcategory-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.subcategory-card {
  width: calc(25% - 10px); /* 4 columns with some spacing */
  margin-bottom: 20px;
  border: 1px solid #ccc; /* Add border to each card */
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}

.subcategory-image {
  max-width: 100%;
  height: auto;
}

.subcategory-title {
  margin-top: 10px;
}
</style>
